import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const feesKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'fees'] as const;
  return createQueryKey({
    all: [...key] as const, // every student/fees query for a specific cause that we have
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...key, uuid] as const,
        detail: [...key, uuid, 'detail'] as const,
        stats: [...key, uuid, 'stats'] as const,
        import: [...key, uuid, 'import'] as const,
      }),
    export: [...key, 'export'] as const,
  });
};

export { feesKeys };
